import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'babel-polyfill' // ie8-11

// import ElementUI from 'element-ui'
import { Tabs, RadioGroup, RadioButton, TabPane, Progress, DatePicker, Breadcrumb, BreadcrumbItem, Rate, Upload, Dialog } from 'element-ui';

import 'style/reset.css'
import 'style/border.css'
import 'style/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/override-element-ui.css';

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Tabs);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(TabPane);
Vue.use(Progress);
Vue.use(DatePicker);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Rate);
Vue.use(Upload);
Vue.use(Dialog);
Vue.config.productionTip = false;

//tost
import 'common/toast/toast.css';
import Toast from 'common/toast/index';
Vue.use(Toast);

//request 
import request from 'js/request';
Vue.prototype.$request = request;

import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

// switchWeb
import switchWeb from 'js/switchWeb';
Vue.use(switchWeb);

//routers 
import routers from 'vue-router'
Vue.prototype.$routers = routers;

//axios
import axios from 'axios'
Vue.prototype.$axios = axios


// set title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})

// baidu tongji
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
    var hm = document.createElement("script");
    //  测试环境
    //  hm.src = "https://hm.baidu.com/hm.js?"+ '11f9fe669ec94fa5097594da350779d2';
    //  正式环境
    hm.src = "https://hm.baidu.com/hm.js?" + '1033eb8bf9578881b70947597f7ba892';
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});


// WEBPACK FOOTER //
// ./src/main.js